import { useDateRange } from '../context/DateRangeContext';
import { ChartsSection } from './ChartsSection';
import { LinkTrackingSection } from './LinkTrackingSection';
import { CsatSection } from './components/CsatSection';
import { TtfrSection } from './components/TtfrSection';
import { useHandoffAnalytics } from './hooks/useHandoffAnalytics.hook';
import { DateRangeControls } from '@/Domain/components/Shared/DateRangeControls/DateRangeControls';
import { Separator } from '@/Domain/components/Shared/Separator/Separator';
import { useLinkTracking } from '@/Domain/hooks/Analytics/useLinkTracking.hook';

export const AiInsightsPage = () => {
  const { range, handleRangeChange } = useDateRange();
  const {
    data,
    isLinkTrackingActive,
    handleToggleLinkTracking,
    isLoading,
    isError,
    isPlaceholderData,
    sorting,
    pagination,
    setPagination,
    setSorting,
  } = useLinkTracking(range);
  const { csatData, isCsatLoading, ttfrData, isTtfrLoading } = useHandoffAnalytics(range);

  return (
    <div className="max-w-7xl mx-auto py-6 space-y-6">
      {/* Date Range Controls */}
      <DateRangeControls range={range} onRangeChange={handleRangeChange} />

      <ChartsSection startDate={range.startDate} endDate={range.endDate} />

      <Separator />

      <LinkTrackingSection
        data={data}
        isLoading={isLoading}
        isError={isError}
        isPlaceholderData={isPlaceholderData}
        isLinkTrackingActive={!!isLinkTrackingActive}
        onToggleLinkTracking={handleToggleLinkTracking}
        sorting={sorting}
        pagination={pagination}
        setPagination={setPagination}
        setSorting={setSorting}
      />

      <Separator />

      <CsatSection data={csatData} isLoading={isCsatLoading} />

      <Separator />

      <TtfrSection data={ttfrData} isLoading={isTtfrLoading} />
    </div>
  );
};
